import { COMPANY_EMAIL, COMPANY_NAME } from '../config/siteInfo';
import { ABOUT_IMAGE, FEATURED_PROJECTS, HERO_IMAGE, SHOWCASE_GALLERY } from '../config/siteImages';

export const defaultContent = {
  siteSettings: {
    siteName: COMPANY_NAME,
    contactEmail: COMPANY_EMAIL,
    phone: '+44 (0) 1234 567 890',
    location: 'Midlands, United Kingdom',
  },
  seo: {
    title: COMPANY_NAME,
    description:
      'Dragon Metalworks — structural and architectural steel fabrication in the UK. Fast quotes, clear specs, dependable delivery.',
  },
  hero: {
    eyebrow: COMPANY_NAME,
    heading: 'Precision steelwork for',
    subheading: 'contractors & private clients',
    paragraph:
      'Structural frames, architectural steel, and bespoke fabrication — delivered with clear communication, quality workmanship, and dependable timelines.',
    primaryCtaLabel: 'Get a Quote',
    secondaryCtaLabel: 'View Projects',
    trustChips: ['Structural steel', 'Architectural steel', 'Bespoke fabrication'],
    imageUrl: HERO_IMAGE,
    imageAlt: 'Structural steel beams on site',
    badgeNumber: '15+',
    badgeLabel: 'Years experience',
    cardKicker: 'Bespoke steel solutions',
    cardMeta: 'Fast quotes • Clear specs • Clean installs',
  },
  servicesSection: {
    eyebrow: 'What We Do',
    title: 'Our Services',
    subtitle:
      'London-based structural steel, architectural metalwork, staircases, and on-site welding — precision fabrication from design to installation.',
    items: [
      {
        name: 'Steel Fabrication',
        description:
          'We are experienced steel fabricators based in London, working on projects of all sizes and complexity.\nOur team combines skill and precision to produce strong, reliable, and high-quality metalwork every time.',
      },
      {
        name: 'Structural Steel',
        description:
          'From basic steel components to complex structural frameworks, we handle all types of structural steelwork for your project.\nOur team ensures strong, accurate, and reliable construction solutions from start to finish.',
      },
      {
        name: 'Architectural Landscape Products',
        description:
          'We create custom architectural steel products for outdoor spaces, working with designers and contractors on landscape and rooftop projects.',
      },
      {
        name: 'Staircases',
        description:
          'We design, fabricate, and install custom steel staircases for residential and commercial projects, combining functionality with modern design and long-lasting quality.',
      },
      {
        name: 'Mobile Welding',
        description:
          'We offer fast and reliable mobile welding services, bringing professional welding and steel repair work directly to your site.',
      },
      { name: 'Steel Supply', description: 'Reliable supply of high-quality steel materials for projects of all sizes.' },
      {
        name: 'Steel Beams',
        description: 'Precision steel beam solutions for strong and dependable structural support.',
      },
      {
        name: 'Steel Columns',
        description: 'Fabricated steel columns designed for strength, stability, and accuracy.',
      },
      { name: 'Design', description: 'Practical and buildable steel design solutions tailored to project requirements.' },
      {
        name: 'Steel Connections',
        description: 'Accurate steel connection fabrication for safe and secure assembly.',
      },
      {
        name: 'Steel Sections',
        description: 'Supply and fabrication of steel sections to meet exact project specifications.',
      },
      {
        name: 'Site Surveys',
        description: 'On-site surveys to assess dimensions, requirements, and installation planning.',
      },
      { name: 'Gates', description: 'Custom steel gates built for security, durability, and modern appearance.' },
      {
        name: 'Balustrades',
        description: 'Architectural steel balustrades designed for safety and clean finishes.',
      },
      {
        name: 'Mezzanines',
        description: 'Strong mezzanine steel structures designed to maximise internal space.',
      },
      {
        name: 'Railing',
        description: 'Durable steel railing solutions for residential, commercial, and outdoor use.',
      },
      {
        name: 'Welding',
        description: 'Professional welding services for fabrication, repairs, and on-site work.',
      },
    ],
  },
  aboutSection: {
    eyebrow: 'About Us',
    title: 'About Us – Dragon Metalworks',
    subtitle:
      'Dragon Metalworks is a London-based steel fabrication company specialising in all aspects of structural steel and custom metalwork.',
    paragraph:
      'We design, fabricate, and install a wide range of steelwork, including structural steel, gates, railings, staircases, balconies, mezzanines, and bespoke metal solutions for residential and commercial projects.\n\nOur team handles everything from design and fabrication to site installation, ensuring every project is completed with precision, strength, and attention to detail.\n\nFrom large structural frameworks to detailed finishing work, we cover all types of steel fabrication with reliable quality and workmanship.\n\nStrong steel. Professional finish. Built to last.',
    imageUrl: ABOUT_IMAGE,
    imageAlt: `${COMPANY_NAME} fabrication workshop`,
    pillars: [],
    certTags: [],
  },
  projectsSection: {
    eyebrow: 'Selected work',
    title: 'Featured projects',
    subtitle:
      'Structural frames, architectural steel, and precision-fabricated details — delivered with the same rigour whether the job is large or bespoke.',
    items: FEATURED_PROJECTS.map((p) => ({
      name: p.name,
      category: p.cat,
      imageUrl: p.image,
      ariaLabel: `${p.name}, ${p.cat}. Open quote request.`,
    })),
  },
  gallerySection: {
    eyebrow: 'In the workshop & on site',
    title: 'Craft you can see',
    subtitle:
      'Real steel, real projects — a glimpse of how we design, fabricate, and deliver structural and architectural metalwork.',
    items: SHOWCASE_GALLERY.map((g) => ({ imageUrl: g.src, alt: g.alt })),
  },
  footer: {
    brandDescription:
      'Premium structural and architectural steel fabrication — engineered, fabricated, and delivered with precision.',
    serviceLinks: [
      'Steel fabrication',
      'Steel beams & columns',
      'Design & connections',
      'Staircases & mezzanines',
      'Gates & balustrades',
      'Welding & site surveys',
    ],
    socialLinks: [
      { label: 'LinkedIn', url: 'https://www.linkedin.com' },
      { label: 'Facebook', url: 'https://www.facebook.com' },
      { label: 'Instagram', url: 'https://www.instagram.com' },
    ],
  },
};

